import * as z from 'zod'
import type {
  KeywordAssignment,
  KeywordType,
  ProducttypeNameRow,
  ProducttypeSalesRow,
  ProducttypeTrafficRow,
  ProducttypeKeywordRow,
} from '@/api/keywordAnalysis/types'

const keywordTypeSchema: z.ZodType<KeywordType> = z.union([
  z.literal(0),
  z.literal(1),
  z.literal(2),
  z.literal(3),
])

export const producttypeSalesRowSchema: z.ZodType<ProducttypeSalesRow> = z.object({
  producttypeKey: z.string(),
  sales365: z.number(),
})

export const producttypeNameRowSchema: z.ZodType<ProducttypeNameRow> = z.object({
  producttypeKey: z.string(),
  producttypeName: z.string(),
})

export const producttypeTrafficRowSchema: z.ZodType<ProducttypeTrafficRow> = z.object({
  producttypeKey: z.string(),
  traffic: z
    .number()
    .nullable()
    .transform((value) => value ?? 0),
})

const keywordAssignmentSchema: z.ZodType<KeywordAssignment> = z.object({
  keywordId: z.number().int(),
  value: z.string(),
  languageKey: z.string(),
  keywordType: keywordTypeSchema,
  isAlias: z.boolean(),
  searchVolumePerMonthAvg: z.number().nullable(),
})

export const producttypeKeywordRowSchema: z.ZodType<ProducttypeKeywordRow> = z.object({
  producttypeKey: z.string(),
  keyword: keywordAssignmentSchema,
})
